<template>
  <z-expansion-config-item 
    :titulo="descricao"
    :subtitulo="ajuda" 
  >
    <v-switch
      v-model="store.configuracoes[config]"
      :label="store.configuracoes[config] ? 'Ativado' : 'Desativado'"
      left
      hide-details
      class="mt-0 pt-0 switch-reverse"
      @change="updateConfig"
    ></v-switch>
  </z-expansion-config-item>
</template>

<script setup>
import { ref, getCurrentInstance } from 'vue';
import { useConfigStore } from '@/app/store/pinia/configuracoes'
const { proxy } = getCurrentInstance();

const store = useConfigStore();
const $store = proxy.$store;

const props = defineProps({
  config: {
    type: String,
    required: true
  },
  descricao: {
    type: String,
    default: ''
  },
  ajuda: {
    type: String,
    default: ''
  }
})

// const configuracao = ref(props.configuracao);

async function updateConfig() {
  $store.commit('UPDATE_CONFIGURACAO', {
    config: props.config,
    valor: store.configuracoes[props.config],
  });

  await store.salvarConfiguracao({
    ...props,
    valor: store.configuracoes[props.config],
    tipo: 'boolean',
  });
}

</script>

<style lang="scss" scoped>

.switch-reverse :deep(.v-input__slot) {
  flex-direction: row-reverse;

  label {
    width: 100px;
  }
}

</style>
